<app-navbar [title]="pageTitle">
	<button class="btn btn-primary me-3" *ngIf="editable" (click)="checkSubmit()">Zapisz</button>
	<button class="btn btn-info me-3" *ngIf="!editable" (click)="duplicate()">Duplikuj</button>
	<button class="btn btn-primary me-3" *ngIf="!editable" (click)="editUnlock()">Edycja</button>
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<div class="container my-4">
	<form class="my-4" (submit)="submit()">
		<fieldset [disabled]="!editable">
			<div class="row">
				<div class="col">
					<div class="form-floating mb-3" matTooltip="Nazwa generuje się na stronie i w systemie">
						<mat-form-field class="w-100">
							<mat-label>Nazwa promocji *</mat-label>
							<input type="text" matInput name="name" [(ngModel)]="data.name" />
						</mat-form-field>
					</div>
					<div
						class="mb-3"
						matTooltip="Wpływa na przydział etykiety na stronie przy ofercie, której zniżka dotyczy oraz możliwość filtrowania. Np First-Minute"
					>
						<ng-select
							id="catalog"
							name="catalog"
							class="custom-ng-select"
							[(ngModel)]="data.catalog"
							placeholder="Katalog promocji *"
							[disabled]="!editable"
							required
						>
							<ng-option *ngFor="let item of catalogs" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div
						class="form-floating mb-3"
						matTooltip="Im większa wartość tym większa ważność. Czyli ? Jeżęli mamy 2 promocje w ofercie: Last-Minute 20 %, ważność 10 oraz Dzień Dziacka -100 pln,ważność 5. To oferta będzie umniejszona o 20% a później o 100 pln"
					>
						<mat-form-field class="w-100">
							<mat-label>Ważność promocji</mat-label>
							<input type="number" matInput min="0" name="importance" [(ngModel)]="data.importance" />
						</mat-form-field>
					</div>
					<label class="form-label" for="description">Opis</label>
					<div class="form-floating mb-3" matTooltip="Wewnętrzny opis - nie jest nigdzie publikowany">
						<ckeditor
							id="description"
							name="description"
							[(ngModel)]="data.description"
							[editor]="editor"
							[disabled]="!editable"
							[config]="editorConfig"
						></ckeditor>
					</div>
					<div class="mb-3">
						<ng-select
							id="isActive"
							name="isActive"
							class="custom-ng-select"
							[(ngModel)]="data.isActive"
							placeholder="Status"
							[disabled]="!editable"
							required
						>
							<ng-option *ngFor="let item of isActiveOptions" [value]="item.enum">{{
								item.name
							}}</ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<ng-select
							id="method"
							name="method"
							class="custom-ng-select"
							[(ngModel)]="data.method"
							(change)="data.methodValue = convertPriceByKind(data.methodValue, data.method)"
							placeholder="Typ"
							[disabled]="!editable"
							required
						>
							<ng-option *ngFor="let item of promoMethod" [value]="item.enum">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="form-floating mb-3" matTooltip="Jeśli chcesz 30% wpisz 30">
						<mat-form-field class="w-100">
							<mat-label>Wartość</mat-label>
							<input
								type="number"
								matInput
								min="0"
								name="methodValue"
								[ngModel]="
									data.method === 'V'
										? data.methodValue
											? (data.methodValue | price)
											: null
										: data.methodValue
											? (data.methodValue | PercentValue)
											: null
								"
								(ngModelChange)="
									data.method === 'V'
										? (data.methodValue = convertPriceToGrosze($event))
										: (data.methodValue = convertPriceToPermill($event))
								"
							/>
						</mat-form-field>
					</div>
					<div
						class="form-floating mb-3"
						matTooltip="dla której zniżka ma zostać zastosowana np. jeśli cennik “Dorosły z HB” wynosi co najmniej 1000 zł to zniżka zostanie zastosowana"
					>
						<mat-form-field class="w-100">
							<mat-label>Min wartość cennika</mat-label>
							<input
								type="number"
								matInput
								min="0"
								name="min_price"
								[ngModel]="data.priceRange.lower ? (data.priceRange.lower | price) : null"
								(ngModelChange)="data.priceRange.lower = convertPriceToGrosze($event)"
							/>
						</mat-form-field>
					</div>
					<div
						class="form-floating mb-3"
						matTooltip="tooltip dla której zniżka ma zostać zastosowana np. jeśli cennik “Dorosły z HB” wynosi nie więcej niż 1000 zł to zniżka zostanie zastosowana"
					>
						<mat-form-field class="w-100">
							<mat-label>Max wartość cennika</mat-label>
							<input
								type="number"
								matInput
								min="0"
								name="max_price"
								[ngModel]="data.priceRange.upper ? (data.priceRange.upper | price) : null"
								(ngModelChange)="data.priceRange.upper = convertPriceToGrosze($event)"
							/>
						</mat-form-field>
					</div>
					<div
						class="mb-3"
						matTooltip="zastosuj jeśli ta promocja ma być dostępna tylko wtedy jeśli inna promocja zostanie naliczona, numer po myślniku oznacza ważność"
					>
						<ng-select
							[items]="promotions"
							id="promotion_whitelist"
							name="promotion_whitelist"
							class="custom-multi-select"
							[(ngModel)]="data.allowedPromotions"
							placeholder="Oferuj z promocją"
							bindValue="id"
							[disabled]="!editable"
							[multiple]="true"
							required
						>
							<ng-template ng-label-tmp let-item="item" let-clear="clear">
								<span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
								<span class="ng-value-label" (click)="goToLink('/promotions/' + item.id)">
									{{ item.id }}. {{ item.name }}
									<span *ngIf="item.importance"> - waż. {{ item.importance }}</span>
								</span>
							</ng-template>
							<ng-template ng-option-tmp let-item="item">
								{{ item.name }}<span *ngIf="item.importance"> - waż. {{ item.importance }}</span>
							</ng-template>
						</ng-select>
					</div>
					<div
						class="col form-check mt-1"
						matTooltip="po zaznaczeniu tej funkcji procentowa promocja oprócz ceny podstawowej będzie naliczana także od usług dodatkowych takich jak np. antenki czy dopłata do SGL"
					>
						<input
							class="form-check-input"
							type="checkbox"
							name="count_automatically"
							id="count_automatically"
							[(ngModel)]="data.countAutomatically"
						/>
						<label class="form-check-label" for="countAutomatically"> Licz dla całej rezerwacji </label>
					</div>
					<div
						class="mb-3"
						matTooltip="Jeżeli chcemy aby promocja też obejmowała pakiet komfort, wybieramy typ: Pakiet Komfort. W przypadku pustego pola promocja będzie tylko nalicza od ceny podstawowej"
					>
						<ng-select
							id="count_services_whitelist"
							name="count_services_whitelist"
							class="custom-multi-select"
							[(ngModel)]="countServicesWhitelist"
							placeholder="Oblicz promocje od typów usług"
							[disabled]="!editable"
							[multiple]="true"
							required
						>
							<ng-option *ngFor="let item of serviceTypes" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
				</div>

				<div class="col">
					<p matTooltip="Okres którym mają zostać objęte oferty tą promocją według daty wyjazdu ">
						Okres ofert
					</p>
					<div class="row mb-3" *ngFor="let item of data.promotionOffers; let index = index">
						<div class="col-10 row">
							<mat-form-field appearance="fill">
								<mat-label>Zakres</mat-label>
								<mat-date-range-input [rangePicker]="picker">
									<input
										matStartDate
										matInput
										placeholder="Data od"
										name="offer_lower_{{ index }}"
										[(ngModel)]="item.offer.lower"
									/>
									<input
										matEndDate
										matInput
										placeholder="Data do"
										name="offer_upper_{{ index }}"
										[(ngModel)]="item.offer.upper"
									/>
								</mat-date-range-input>
								<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
								<mat-date-range-picker #picker></mat-date-range-picker>
							</mat-form-field>
						</div>
						<div class="col-2 row">
							<span class="m-auto w-auto p-0" (click)="delete_promotion_offer(index)"
								><i class="fas fa-minus-circle text-danger m-auto"></i
							></span>
						</div>
					</div>

					<div class="row">
						<span class="m-auto w-auto p-0" (click)="add_promotion_offer()"
							><i class="fas fa-plus-circle m-auto"></i
						></span>
					</div>
					<p matTooltip="Okres w którym promocja ma być dostępna do rezerwacji">Okres sprzedaży</p>
					<div class="row mb-3" *ngFor="let item of data.promotionSells; let index = index">
						<div class="col-10 row">
							<mat-form-field appearance="fill">
								<mat-label>Zakres</mat-label>
								<mat-date-range-input [rangePicker]="picker">
									<input
										matStartDate
										matInput
										placeholder="Data od"
										name="sell_lower_{{ index }}"
										[(ngModel)]="item.sell.lower"
									/>
									<input
										matEndDate
										matInput
										placeholder="Data do"
										name="sell_upper_{{ index }}"
										[(ngModel)]="item.sell.upper"
									/>
								</mat-date-range-input>
								<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
								<mat-date-range-picker #picker></mat-date-range-picker>
							</mat-form-field>
						</div>
						<div class="col-2 row">
							<span class="m-auto w-auto p-0" (click)="delete_promotion_sell(index)"
								><i class="fas fa-minus-circle text-danger m-auto"></i
							></span>
						</div>
					</div>
					<div class="row">
						<span class="m-auto w-auto p-0" (click)="add_promotion_sell()"
							><i class="fas fa-plus-circle m-auto"></i
						></span>
					</div>
					<div
						class="col form-check mt-1"
						matTooltip="Funkcja automatycznie przydziela zniżkę do oferty (jako wartość domyślną). Jeżeli mamy zniżkę na Dzień kobiet to klientka musi potwierdzić że jest kobietą."
					>
						<input
							class="form-check-input"
							type="checkbox"
							name="manual"
							id="manual"
							[(ngModel)]="data.manual"
						/>
						<label class="form-check-label" for="manual"> Zastosuj zniżkę automatyczne </label>
					</div>
					<div
						class="mb-3"
						matTooltip="Wybierz konkretne produkty do których ma zostać zastosowana promocja. Brak jakiekolwiek produktu powdouje zastosowanie promocjo do wszystkich produktów."
					>
						<ng-select
							id="products_whitelist"
							name="products_whitelist"
							class="custom-multi-select"
							[closeOnSelect]="false"
							[(ngModel)]="productsWhitelist"
							placeholder="Oferuj z produktem"
							[disabled]="!editable"
							[multiple]="true"
							[minTermLength]="minLengthProduct"
							[loading]="productLoading"
							loadingText="Wczytywanie..."
							typeToSearchText="Wprowadź {{ minLengthProduct }} lub więcej znaków"
							[typeahead]="productsInput$"
							required
						>
							<ng-option *ngFor="let item of products$ | async" [value]="item.id">{{
								item.name
							}}</ng-option>
						</ng-select>
					</div>
					<div
						class="mb-3"
						matTooltip="Wybierz konkretne produkty do których nie zostanie zastosowana promocja."
					>
						<ng-select
							id="products_blacklist"
							name="products_blacklist"
							class="custom-multi-select"
							[closeOnSelect]="false"
							[(ngModel)]="productsBlacklist"
							placeholder="Nie oferuj z produktem"
							[disabled]="!editable"
							[multiple]="true"
							[minTermLength]="minLengthProduct"
							[loading]="productLoading"
							loadingText="Wczytywanie..."
							typeToSearchText="Wprowadź {{ minLengthProduct }} lub więcej znaków"
							[typeahead]="productsInput$"
							required
						>
							<ng-option *ngFor="let item of products$ | async" [value]="item.id">{{
								item.name
							}}</ng-option>
						</ng-select>
					</div>
					<div
						class="mb-3"
						matTooltip="Wybierz rodzaj produktów do których ma zostać zastosowana promocja, bez wyboru rodzaju produktu, zastosowane będzie do wszystkich rodzajów."
					>
						<ng-select
							id="kinds"
							name="kinds"
							class="custom-multi-select"
							[(ngModel)]="data.kinds"
							placeholder="Rodzaj produktów"
							[disabled]="!editable"
							[multiple]="true"
							required
						>
							<ng-option *ngFor="let item of kinds" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div
						class="mb-3"
						matTooltip="Wybierz konkretne destynacje do których ma zostać zastosowana promocja, bez wyboru destynacji, zastosowane będzie do wszystkich destynacji."
					>
						<ng-select
							id="destination_whitelist"
							name="destination_whitelist"
							class="custom-multi-select"
							[closeOnSelect]="false"
							[(ngModel)]="destinationWhitelist"
							placeholder="Oferuj z destynacją"
							[disabled]="!editable"
							[multiple]="true"
							required
						>
							<ng-option *ngFor="let item of destinations" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div
						class="mb-3"
						matTooltip="wybierz konkretne destynacje do których nie zostanie zastosowana promocja,"
					>
						<ng-select
							id="destination_blacklist"
							name="destination_blacklist"
							class="custom-multi-select"
							[closeOnSelect]="false"
							[(ngModel)]="destinationBlacklist"
							placeholder="Nie oferuj z destynacją"
							[disabled]="!editable"
							[multiple]="true"
							required
						>
							<ng-option *ngFor="let item of destinations" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
				</div>
				<div class="col">
					<div class="input-group mb-3">
						<span class="input-group-text">Liczba noclegów, od:</span>
						<input
							type="number"
							min="0"
							class="form-control"
							name="accommodationNightsFrom"
							id="accommodationNightsFrom"
							[(ngModel)]="data.accommodationNights.lower"
						/>
						<span class="input-group-text">do:</span>
						<input
							type="number"
							min="0"
							class="form-control"
							name="accommodationNightsTo"
							id="accommodationNightsTo"
							[(ngModel)]="data.accommodationNights.upper"
						/>
					</div>
					<div
						class="mb-3"
						matTooltip="Wybierz kanał sprzedaży dla którego promocja ma być aktywna, brak wyboru oznacza aktywność we wszystkich"
					>
						<ng-select
							id="channels"
							name="channels"
							class="custom-multi-select"
							[(ngModel)]="data.sellChannels"
							placeholder="Kanał sprzedaży"
							[disabled]="!editable"
							[multiple]="true"
							required
						>
							<ng-option *ngFor="let item of channels" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<!-- <div
						class="mb-3"
						matTooltip="wybierz kategorię sprzedawcy dla którego promocja ma być aktywna"
					>
						<label
							class="form-label custom-label"
							for="sell_categories"
							>Kategoria sprzedawcy</label
						>
						<ng-select
							id="sell_categories"
							name="sell_categories"
							class="custom-multi-select"
							[(ngModel)]="data.sell_categories"
							placeholder="(wybierz)"
							[disabled]="!editable"
							[multiple]="true"
							required
						>
							<ng-option
								*ngFor="let item of sell_categories"
								[value]="item.id"
								>{{ item.name }}</ng-option
							>
						</ng-select>
					</div>
					<div class="mb-3" matTooltip="Info about the action">
						<label
							class="form-label custom-label"
							for="organizations"
							>Sprzedawca</label
						>
						<ng-select
							id="organizations"
							name="organizations"
							class="custom-multi-select"
							[(ngModel)]="data.organizations"
							placeholder="(wybierz)"
							[disabled]="!editable"
							[multiple]="true"
							required
						>
							<ng-option
								*ngFor="let item of organizations"
								[value]="item.id"
								>{{ item.name }}</ng-option
							>
						</ng-select>
					</div> -->
					<div
						class="mb-3"
						matTooltip="Wybierz przystanek dla którego ma być zaaplikowana promocja, brak wyboru oznacza zoastosowanie do wszystkich przystanków"
					>
						<ng-select
							id="stops"
							name="stops"
							[closeOnSelect]="false"
							class="custom-multi-select"
							[(ngModel)]="data.stops"
							placeholder="Przystanek"
							[disabled]="!editable"
							[multiple]="true"
							required
						>
							<ng-option *ngFor="let item of stops" [value]="item.location.id"
								>{{ item.location.name }} - {{ item.address }}</ng-option
							>
						</ng-select>
					</div>
					<div
						class="mb-3"
						matTooltip="Wybór rodzaju transport, brak wyboru oznacza aplikacje promocji do wszystkich"
					>
						<ng-select
							id="transports"
							name="transports"
							class="custom-multi-select"
							[(ngModel)]="data.transports"
							placeholder="Transport"
							[disabled]="!editable"
							[multiple]="true"
							required
						>
							<ng-option *ngFor="let item of transportTypes" [value]="item.id">{{ item.kind }}</ng-option>
						</ng-select>
					</div>
					<div
						class="mb-3"
						matTooltip="Np. Promocja dla stałych klietnów  tylko w przypadku usługi Karta Stałego Klineta"
					>
						<ng-select
							id="services_whitelist"
							name="services_whitelist"
							class="custom-multi-select"
							[(ngModel)]="servicesWhitelist"
							placeholder="Tylko w przypadku usług"
							[disabled]="!editable"
							[multiple]="true"
							required
						>
							<ng-option *ngFor="let item of services" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="mb-3" matTooltip="Np. promocja FM 30% nie zadziała z Karta Dużej rodziny">
						<ng-select
							id="services_blacklist"
							name="services_blacklist"
							class="custom-multi-select"
							[(ngModel)]="servicesBlacklist"
							placeholder="Nie w przypadku usług"
							[disabled]="!editable"
							[multiple]="true"
							required
						>
							<ng-option *ngFor="let item of services" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div
						class="mb-3"
						matTooltip="Wybierz wyżywienie dla którego ma zostać zastosowana promocja,brak wyboru oznacza aplikacje do wszystkich wyżywień"
					>
						<ng-select
							id="boards"
							name="boards"
							class="custom-multi-select"
							[(ngModel)]="data.boards"
							placeholder="Wyżywienie"
							[disabled]="!editable"
							[multiple]="true"
							required
						>
							<ng-option *ngFor="let item of boards" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
				</div>
			</div>
			<legend>Płatności</legend>

			<div class="row">
				<div class="col">
					<div class="mb-3">
						<ng-select
							id="payAdvTermMethod"
							name="payAdvTermMethod"
							class="custom-ng-select"
							[(ngModel)]="data.payAdvTermMethod"
							placeholder="Termin zaliczki"
							[disabled]="!editable"
							required
						>
							<ng-option *ngFor="let item of termMethod" [value]="item.enum">{{ item.name }}</ng-option>
						</ng-select>
					</div>
				</div>
				<div class="col">
					<div [ngSwitch]="data.payAdvTermMethod">
						<div *ngSwitchCase="'D'" class="form-floating mb-3 column">
							<input
								type="date"
								class="form-control"
								name="payAdvTermDate"
								[(ngModel)]="data.payAdvTermDate"
								required
							/>
							<label>Data od</label>
						</div>
						<div *ngSwitchCase="'B'" class="form-floating mb-3">
							<mat-form-field class="w-100">
								<mat-label>Wartość </mat-label>
								<input
									type="number"
									matInput
									min="0"
									name="payAdvTermValue"
									[(ngModel)]="data.payAdvTermValue"
								/>
							</mat-form-field>
						</div>
						<div *ngSwitchCase="'A'" class="form-floating mb-3">
							<mat-form-field class="w-100">
								<mat-label>Wartość</mat-label>
								<input
									type="number"
									matInput
									min="0"
									name="payAdvTermValue"
									[(ngModel)]="data.payAdvTermValue"
								/>
							</mat-form-field>
						</div>
					</div>
				</div>
				<div class="col">
					<div class="mb-3">
						<ng-select
							id="payAdvCountKind"
							name="payAdvCountKind"
							class="custom-ng-select"
							[(ngModel)]="data.payAdvCountKind"
							placeholder="Typ zaliczki"
							(change)="
								data.payAdvCountValue = convertPriceByKind(data.payAdvCountValue, data.payAdvCountKind)
							"
							[disabled]="!editable"
							required
						>
							<ng-option *ngFor="let item of payAdvMethod" [value]="item.enum">{{ item.name }}</ng-option>
						</ng-select>
					</div>
				</div>
				<div class="col">
					<div class="form-floating mb-3">
						<mat-form-field class="w-100">
							<mat-label>Wartość</mat-label>
							<input
								type="number"
								matInput
								min="0"
								name="payAdvCountValue"
								[ngModel]="
									data.payAdvCountKind === 'V'
										? data.payAdvCountValue
											? (data.payAdvCountValue | price)
											: null
										: data.payAdvCountValue
											? (data.payAdvCountValue | PercentValue)
											: null
								"
								(ngModelChange)="
									data.payAdvCountKind === 'V'
										? (data.payAdvCountValue = convertPriceToGrosze($event))
										: (data.payAdvCountValue = convertPriceToPermill($event))
								"
							/>
						</mat-form-field>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col">
					<div class="mb-3">
						<ng-select
							id="payFullTermMethod"
							name="payFullTermMethod"
							class="custom-ng-select"
							[(ngModel)]="data.payFullTermMethod"
							placeholder="Termin dopłaty do całości *"
							[disabled]="!editable"
							required
						>
							<ng-option *ngFor="let item of termMethod" [value]="item.enum">{{ item.name }}</ng-option>
						</ng-select>
					</div>
				</div>
				<div class="col">
					<div [ngSwitch]="data.payFullTermMethod">
						<div *ngSwitchCase="'D'" class="form-floating mb-3 column">
							<input
								type="date"
								class="form-control"
								name="payFullTermDate"
								[(ngModel)]="data.payFullTermDate"
								required
							/>
							<label>Data<small class="ms-2 text-danger">* wymagane</small> </label>
						</div>
						<div *ngSwitchCase="'B'" class="form-floating mb-3">
							<mat-form-field class="w-100">
								<mat-label>Wartość *</mat-label>
								<input
									type="number"
									matInput
									min="0"
									name="payFullTermValue"
									[(ngModel)]="data.payFullTermValue"
									class="pt-1"
								/>
							</mat-form-field>
						</div>
						<div *ngSwitchCase="'A'" class="form-floating mb-3">
							<mat-form-field class="w-100">
								<mat-label>Wartość *</mat-label>
								<input
									type="number"
									matInput
									min="0"
									name="payFullTermValue"
									[(ngModel)]="data.payFullTermValue"
								/>
							</mat-form-field>
						</div>
					</div>
				</div>
				<div class="col-6"></div>
			</div>
		</fieldset>
	</form>
</div>
